import React, { useState, useEffect } from 'react';
import './Design.scss';

const Design = ({ setProductPosition }) => {
  const [target, setTarget] = useState(null);

  const onIntersect = async ([entry], observer) => {
    if (entry.isIntersecting) {
      observer.unobserve(entry.target);
      setProductPosition(target.id);
      observer.observe(entry.target);
    }
  };

  useEffect(() => {
    let observer;
    if (target) {
      observer = new IntersectionObserver(onIntersect, { threshold: 0.5 });
      observer.observe(target);
    }
    return () => observer && observer.disconnect();
  });
  return (
    <div className="design">
      <div id="Design" className="designSecond" ref={setTarget}>
        <div className="designSecondContentsTitle">
          클래식하고 심플한 디자인
        </div>
        <div className="designSecondImage">
          <img
            className="designSecondImageDetail"
            src="/images/Assembly_white.png"
            alt="DesignImg"
          />
          <img
            className="designSecondImageDetail"
            src="/images/v6_65.png"
            alt="DesignImg"
          />
        </div>
        <div className="designSecondContentsInfo">
          <p>터보팬 엔진에서 영감을 받은 디자인은</p>
          <p>고도의 기술과 신뢰도를 상징합니다.</p>
          <br />
          <p>어떤 컨셉의 캠핑장비와도 잘 어울리는</p>
          <p> TUF의 클래식 디자인은</p>
          <p>오랜 시간이 지나도 질리지 않는 만족감을 드립니다.</p>
        </div>
      </div>
    </div>
  );
};

export default Design;
